import { Row, Col, Form, Button, Schema } from "rsuite";
import { Container } from "react-bootstrap";
import { useOrderCreation } from "../context/OrderCreationContext";
import { authUserData } from "../../../../../service";

const passengerNameRule = Schema.Types.StringType().isRequired('護照姓名為必填欄位.');
const passengerPhoneRule = Schema.Types.StringType().isRequired('乘客手機號碼為必填欄位.');
const passengerEmailRule = Schema.Types.StringType().isEmail('請輸入正確的Email格式.');

export const PassengerInfo: React.FC = () => {
  const {
    refFormPassenger,
    passengerFormValue,
    setPassengerFormValue,
    setPassengerName,
    setPassengerPhone,
    setPassengerEmail,
    setPassengerID,
    setStep
  } = useOrderCreation();

  const authUser = authUserData();

  const handleFormPassengerSubmit = () => {
    refFormPassenger.current!.checkAsync().then(result => {
      if (!result.hasError) {
        setPassengerName(passengerFormValue.passengerName);
        setPassengerPhone(passengerFormValue.passengerPhone);
        if (passengerFormValue.passengerEmail && passengerFormValue.passengerEmail.length > 0) {
          setPassengerEmail(passengerFormValue.passengerEmail);
        }
        setPassengerID('');
        setStep(5);
      }
    });
  };

  return (
    <Container fluid="md" style={{ backgroundColor: 'white' }} className="rounded">
      <br />
      <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
        <Row>
          <Col style={{ textAlign: 'left' }}>
            <h6>為符合交通法規規定，旅客資料僅用於本次預約所使用</h6>
          </Col>
        </Row>
      </div>
      <br />

      <Form
        ref={refFormPassenger}
        onChange={setPassengerFormValue}
        formValue={passengerFormValue}
        style={{ paddingLeft: '15px', paddingRight: '15px' }}
      >
        <Form.Group className="mb-3" style={{ textAlign: 'left' }}>
          <Form.ControlLabel>姓名</Form.ControlLabel>
          <Form.Control name="passengerName" rule={passengerNameRule} placeholder="" />
        </Form.Group>

        <Form.Group className="mb-3" style={{ textAlign: 'left' }}>
          <Form.ControlLabel>電話</Form.ControlLabel>
          <Form.Control name="passengerPhone" rule={passengerPhoneRule} placeholder="範例:09xx" />
        </Form.Group>

        {authUser && authUser.email.toString().length > 0 ? (
          <Form.Group className="mb-3" style={{ textAlign: 'left' }}>
            <Form.ControlLabel>Email (系統預設為您的帳戶Email)</Form.ControlLabel>
            <Form.Control
              name="passengerEmail"
              rule={passengerEmailRule}
              placeholder=""
              value={authUser.email}
              readOnly
            />
          </Form.Group>
        ) : (
          <Form.Group className="mb-3" style={{ textAlign: 'left' }}>
            <Form.ControlLabel>Email</Form.ControlLabel>
            <Form.Control
              name="passengerEmail"
              rule={passengerEmailRule}
              placeholder="example@example.com"
            />
          </Form.Group>
        )}

        <br />
        <Form.Group className="mb-3" style={{ textAlign: 'left' }}>
          <Button appearance="default" type="submit" onClick={handleFormPassengerSubmit}>
            儲存資料
          </Button>
        </Form.Group>
        <br />
      </Form>
    </Container>
  );
};
